import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { Button } from "sulu-admin-bundle/components";
import MatchDayDelete from "./MatchDayDelete";
import MatchDayDraggable from "./MatchDayDraggable";
import PortalAwareItem from "./PortalAwareItem";

const MatchItem = ({
  board,
  bIndex,
  identifier,
  date,
  onAddMatchRow,
  deleteAction,
  valueLength,
  portal,
  handleTimeChange,
}) => {
  //   console.log(board.id, board.time);
  return (
    <div className="matches__row">
      <Droppable
        droppableId={`arow/${identifier}/${board.id}`}
        type="row"
        isCombineEnabled={false}
      >
        {(rprovided, rsnapshot) => {
          return (
            <div className="matches__match">
              <div
                className="matches__droppable"
                {...rprovided.droppableProps}
                ref={rprovided.innerRef}
              >
                <Draggable draggableId={board.id} index={bIndex}>
                  {(innerDragProvided, innerDragSnap) => {
                    return (
                      <PortalAwareItem
                        portal={portal}
                        usePortal={innerDragSnap.isDragging}
                        child={
                          <MatchDayDraggable
                            board={board}
                            innerDragProvided={innerDragProvided}
                            portal={portal}
                            placeholder={rprovided.placeholder}
                          />
                        }
                      />
                    );
                  }}
                </Draggable>
                {/* {rprovided.placeholder} */}
              </div>
              <MatchDayDelete
                // datetime={board.time}
                datetime={board.time ? new Date(board.time) : null}
                handleTimeChange={(v, e) => handleTimeChange(v, board)}
                action={deleteAction}
              />
            </div>
          );
        }}
      </Droppable>

      {bIndex === valueLength - 1 && (
        <Button
          className="matches__addrowbutton"
          skin="primary"
          onClick={() => onAddMatchRow(date, identifier)}
        >
          add row
        </Button>
      )}
    </div>
  );
};

export default MatchItem;
